import { useEffect, useState } from "react";
import "./Auth/register/auth.component.scss";
import "./layout.component.scss";
import logo from "./../assets/logos/logo_white.svg";
import { useSelector } from "react-redux";
import { Header } from "./Common/Header/Header";
import { useLocation, useNavigate } from "react-router";
import { MobileDefault } from "./MobileDefault";
import { useMediaQuery } from "@mui/material";
import PageLoader from "./Common/Loader/PageLoader";
import PropTypes from "prop-types";

export const AuthLayout = ({ children }) => {
  const navigate = useNavigate();

  const authReducer = useSelector((state) => state.authReducer);
  const [NavBar, setNavBar] = useState(false);
  const loaderReducer = useSelector((state) => state.loaderReducer);
  const path = useLocation();
  const subscriptionReducer = useSelector((state) => state.subscriptionReducer);
  const orgReducer = useSelector((state) => state?.orgReducer);
  const isMobile = useMediaQuery("(max-width: 1224px)");
  const isLoggedIn = Boolean(authReducer?.isLogin);
  const isLoginPath = path.pathname.includes("login");
  const isPublicAuthPath =
    path.pathname.includes("login") ||
    path.pathname.includes("forgot") ||
    path.pathname.includes("register") ||
    path.pathname.includes("user-management-register") ||
    path.pathname.includes("email-verified") ||
    path.pathname.includes("activate") ||
    path.pathname.includes("reset");

  useEffect(() => {
    if (globalThis.location.origin + "/" === globalThis.location.href) {
      navigate("/user/login", { state: { directLogout: true } });
    }
  }, [navigate]);

  useEffect(() => {
    let hideTimeout;

    const hideElement = () => {
      const element = document.querySelector(".chmln-list-container");
      if (element) {
        if (subscriptionReducer?.isPro === false) {
          element.style.display = "none";
        }
      } else {
        // If the element doesn't exist, wait for a short time and then check again
        hideTimeout = setTimeout(hideElement, 100); // Check again after 100 milliseconds
      }
    };

    // Initial call to start checking for the element
    hideElement();

    // Cleanup function to clear any pending timeouts if the component unmounts
    // Wait for the entire document to be loaded before checking for the element
    document.addEventListener("DOMContentLoaded", hideElement);

    // Cleanup function to remove event listener when the component unmounts
    return () => {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
      }
      document.removeEventListener("DOMContentLoaded", hideElement);
    };
  }, [subscriptionReducer?.isPro]);

  useEffect(() => {
    const handleDashboardClick = () => {
      const containerListElement = document.querySelector(
        "#chmln-dom #chmln-list-6423ca97665897001783d13a .chmln-list .chmln-list-items",
      );

      if (!containerListElement) {
        return;
      }

      const firstLiElement = containerListElement.querySelector("li button");

      const secondLiElement = containerListElement.querySelector(
        "li:nth-child(2) button",
      );

      if (!firstLiElement || !secondLiElement) {
        return;
      }

      const isDefaultOrg =
        orgReducer?.orguid === "00000000-0000-aaaa-aaaa-000000000000";
      secondLiElement.style.display = isDefaultOrg ? "none" : "flex";
      firstLiElement.style.display = isDefaultOrg ? "flex" : "none";
    };

    const intervalId = setInterval(() => {
      const containerElement = document.querySelector("#chmln-dom");

      if (containerElement) {
        const containerListElement = document.querySelector(
          "#chmln-dom #chmln-list-6423ca97665897001783d13a .chmln-list .chmln-list-items",
        );

        if (containerListElement) {
          const firstLiElement =
            containerListElement.querySelector("li button");

          const secondLiElement = containerListElement.querySelector(
            "li:nth-child(2) button",
          );

          if (firstLiElement && secondLiElement) {
            const isDefaultOrg =
              orgReducer?.orguid === "00000000-0000-aaaa-aaaa-000000000000";
            secondLiElement.style.display = isDefaultOrg ? "none" : "flex";
            firstLiElement.style.display = isDefaultOrg ? "flex" : "none";
          }
        }
        containerElement.addEventListener("click", handleDashboardClick);

        clearInterval(intervalId);
      }
    }, 100);

    return () => {
      clearInterval(intervalId);

      const containerElement = document.querySelector("#chmln-dom");
      if (containerElement) {
        containerElement.removeEventListener("click", handleDashboardClick);
      }
    };
  }, [loaderReducer.loader]);


  if (isPublicAuthPath) {
    return (
      <div className="d-flex flex-column flex-root">
        <div
          className="d-block d-md-flex bg-white blockForBigScreen  h-100"
          id="auth_layout"
          style={{ minHeight: "100vh" }}
        >
          <div
            className="d-flex flex-column flex-lg-row-auto bg-bondai-auth pt-lg-0 col-12 col-sm-12 col-md-5"
            style={{ minHeight: "100vh" }}
          >
            <div className="lading_page_background_img h-100">
              <div className="d-flex flex-column-auto flex-column text-center mb-md-5 logoContainer">
                <span className="align-self-md-start text-start my-6 ms-6">
                  <img alt="logo" src={logo} className="img-fluid" />
                </span>
              </div>
            </div>
          </div>
          <div className="login-content align-self-center  flex-lg-row-fluid d-flex flex-column justify-content-center h-100 py-10 px-10 p-lg-7 mx-auto w-100 bg-white">
            <div className="flex-column-fluid flex-center  p-xxxl-7 mx-auto mw-550px mw-xxl-650px w-100 h-100 routerContainer">
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  } else if (isLoggedIn && isLoginPath === false) {
    return isMobile ? (
      <MobileDefault />
    ) : (
      <div className="desktop h-100">
        <div className="h-100">
          <PageLoader isLoading={loaderReducer.loader} />
          <div className="d-flex flex-column flex-root">
            <div className="page d-flex flex-row flex-column-fluid h-100">
              <div
                className="wrapper d-flex flex-column flex-row-fluid"
                id="wrapper"
              >
                <Header NavBar={NavBar} setNavBar={setNavBar} />
                <div className="page-layout container mt-21">
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ height: "100%", position: "absolute" }}>
          <PageLoader isLoading={loaderReducer.logoutLoading} />
        </div>
        <div style={{ height: "100%", position: "absolute" }}>
          <PageLoader isLoading={loaderReducer.performaLoading} />
        </div>
      </div>
    );
  } 
};

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
};